import { Table } from "@dealer-center/core-components";
import { useWindowDimensions } from "@dealer-center/core-custom-components";
import { useLocaleStore } from "@dealer-center/core-locale";
import { useContext } from "react";
import { getColumns } from "./columns";
import { AccountSearchContext } from "@dealer-center/ddc-pages-account-search-context";
import styled from "styled-components";
import { useAccountFavourites } from "@dealer-center/ddc-api-account-fetch";

// Fix for page size appearing over pagination
// https://coxauto.slack.com/archives/C061AG3B6RZ/p1721930489738519
const StyledTableWrapper = styled.div`
  .ids-table-page-size-selector-bottom {
    width: fit-content;
  }
`;

export const PagesClientSearchResult = () => {
  const {
    size,
    page,
    updatePage,
    updateSize,
    accountSearchGet: accountSearchResult
  } = useContext(AccountSearchContext);
  const getLocaleString = useLocaleStore(state => state.getLocaleString);
  const { currentSize } = useWindowDimensions();
  const { accountFavorites, toggleAccountFavorites } = useAccountFavourites();

  const columns = getColumns(
    toggleAccountFavorites,
    accountFavorites || [],
    currentSize
  );

  return (
    <StyledTableWrapper>
      <Table.Table
        displayPageSizeSelector
        columns={columns}
        currentPageSize={size}
        data={
          (!accountSearchResult?.error && accountSearchResult?.data?.hits) || []
        }
        data-testid="account-search-results-table"
        dataDensity="small"
        emptyText={
          accountSearchResult?.error
            ? getLocaleString("core.ERROR_HEADING")
            : getLocaleString("NO_ACCOUNTS_FOUND")
        }
        expandRowOnClick={false}
        isLoading={accountSearchResult?.isLoading}
        pageSizePosition="bottom"
        paginationCurrent={page + 1}
        rowClassName={() => "interstate-table-class-text-at-top"}
        tableLayout="auto"
        onChangePage={page => {
          updatePage(page - 1);
        }}
        onChangePageSize={size => {
          updateSize(size);
        }}
      />
    </StyledTableWrapper>
  );
};
